package ru.villawonka.app.presentation.screens.searchFilter.compose.layout

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import ru.villawonka.app.platform.platform.model.PlatformType
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.design.theme.surfaceLow
import ru.villawonka.app.presentation.screens.searchFilter.compose.SearchFilterCallbacks
import ru.villawonka.app.presentation.screens.searchFilter.compose.view.AccommodationTypeCardView
import ru.villawonka.app.presentation.screens.searchFilter.compose.view.AdditionsCardView
import ru.villawonka.app.presentation.screens.searchFilter.compose.view.ApplyButtonBlockView
import ru.villawonka.app.presentation.screens.searchFilter.compose.view.BedroomsCardView
import ru.villawonka.app.presentation.screens.searchFilter.compose.view.CityCardView
import ru.villawonka.app.presentation.screens.searchFilter.compose.view.CostRangeCardView
import ru.villawonka.app.presentation.screens.searchFilter.compose.view.DistrictsCardView
import ru.villawonka.app.presentation.screens.searchFilter.viewmodel.SearchFilterUIState

@Composable
fun SearchFilterAccommodationStateLayout(
    platformType: PlatformType,
    state: SearchFilterUIState.Data.Accommodation,
    callbacks: SearchFilterCallbacks,
) {
    Box(
        modifier = Modifier
            .background(MaterialTheme.colors.surfaceLow)
            .fillMaxSize()
    ) {
        val betweenCardSpacing = 8.dp
        val bottomSpacing = 88.dp

        Column(Modifier.verticalScroll(rememberScrollState())) {
            CityCardView(
                selectedCity = state.selectedCity,
                cities = state.cities,
                callbacks = callbacks,
            )
            AppSpacer(betweenCardSpacing)
            if (state.districts.isNotEmpty()) {
                DistrictsCardView(
                    chips = state.districts,
                    callbacks = callbacks,
                )
                AppSpacer(betweenCardSpacing)
            }
            CostRangeCardView(
                costMin = state.minCost,
                costMax = state.maxCost,
                currency = state.currency,
                callbacks = callbacks
            )
            AppSpacer(betweenCardSpacing)
            AccommodationTypeCardView(
                chips = state.accommodationTypes,
                callbacks = callbacks
            )
            AppSpacer(betweenCardSpacing)
            BedroomsCardView(
                chips = state.bedrooms,
                callbacks = callbacks
            )
            AppSpacer(betweenCardSpacing)
            AdditionsCardView(
                chips = state.additions,
                callbacks = callbacks,
            )
            AppSpacer(bottomSpacing)
        }
        ApplyButtonBlockView(platformType, callbacks)
    }
}